export type VoiceRequestToken = {
  isCancelled: () => boolean;
  finish: () => void;
};

export class VoiceRequestCancellation {
  private generation = 0;
  private active = false;

  begin(): void {
    this.generation += 1;
    this.active = true;
  }

  cancel(): void {
    this.generation += 1;
    this.active = false;
  }

  capture(): VoiceRequestToken {
    if (!this.active) this.begin();
    const generation = this.generation;
    return {
      isCancelled: () => !this.active || this.generation !== generation,
      finish: () => {
        if (this.generation === generation) this.active = false;
      },
    };
  }

  isActive(): boolean {
    return this.active;
  }
}
